{
  "page": {
    "title": "To-do and alerts",
    "intro": "Everything the shop has to do or check, most urgent first. Open goes straight to the page where you fix it.",
    "kind": "Kind",
    "status": "Status",
    "mine": "Only mine",
    "error": "The to-do list could not be loaded.",
    "empty_open": "Nothing to do right now",
    "empty_open_body": "New to-dos appear here by themselves.",
    "empty": "No to-dos here.",
    "more": "Show more"
  },
  "kind_tab": {
    "all": "All",
    "alert": "Problems",
    "task": "Tasks",
    "info": "New orders"
  },
  "status_tab": {
    "open": "To do",
    "done": "Done",
    "all": "All"
  },
  "kind": {
    "alert": "Problem",
    "task": "Task",
    "info": "Information"
  },
  "status": {
    "open": "To do",
    "in_progress": "Being handled",
    "done": "Done",
    "dismissed": "Closed"
  },
  "item": {
    "times_one": "×{{count}}",
    "times_other": "×{{count}}",
    "assigned_me": "You are handling this",
    "assigned_to": "Handled by {{name}}",
    "unassigned": "Nobody yet",
    "overdue": "Late since",
    "due": "By",
    "me_name": "{{name}} (me)",
    "someone": "a staff member",
    "you": "you"
  },
  "actions": {
    "open": "Open",
    "reopen": "Not done yet",
    "done": "Done",
    "assign_to": "Who handles it",
    "assign_me": "I will do it",
    "show_detail": "Details for IT",
    "hide_detail": "Hide details"
  },
  "toast": {
    "done": "Marked as done.",
    "reopened": "Back on the to-do list.",
    "assigned": "Now handled by {{name}}.",
    "unassigned": "Nobody handles it now."
  },
  "alerts": {
    "legend": "When a new to-do arrives",
    "sound": "Play a sound",
    "desktop": "Pop-up on this computer",
    "desktop_blocked": "Pop-ups are blocked in this browser"
  },
  "dlq": {
    "for_it": "For IT (no customer data is shown)",
    "service": "Part of the system",
    "subject": "Kind of update",
    "consumer": "Worker",
    "count": "How many",
    "error": "Error (short)",
    "how_to_retry": "IT can also send the updates again with this command:",
    "runbook": "Instructions: {{path}}",
    "retry": "Send again (再送)",
    "retry_explain": "Sends every failed update of this kind once more. When that works, this to-do closes by itself; if one fails again, a new to-do appears.",
    "ask_manager": "Ask the owner or a manager to press “Send again”.",
    "command_title": "For IT: command line",
    "sent_again_one": "Sent {{count}} update again.",
    "sent_again_other": "Sent {{count}} updates again.",
    "some_left_one": "{{count}} update could not be sent again — IT has to look at it.",
    "some_left_other": "{{count}} updates could not be sent again — IT has to look at them."
  },
  "types": {
    "order_new": "New order",
    "payment_confirm_pending": "Bank transfer to confirm",
    "bank_transfer_notice": "Customer says they paid",
    "payment_overdue": "Payment is late",
    "oversell_conflict": "Card sold twice",
    "dlq_message": "Background task failed",
    "low_stock": "Low stock",
    "taxfree_deadline": "Tax-free customs deadline",
    "taxfree_refund_due": "Tax-free refund to pay",
    "export_evidence_missing": "Export proof missing",
    "payout_due": "Consignor payment due",
    "search_inconsistent": "Website search out of date",
    "search_dlq": "Website search update failed",
    "search_lag": "Website search is slow to update",
    "search_document_rejected": "A product could not go into the search",
    "document_integrity_mismatch": "A stored document changed",
    "document_failed": "A document could not be made",
    "notification_failed": "An e-mail could not be sent",
    "webhook_failed": "A chat message could not be sent",
    "document_missing": "A document is missing",
    "tax_alert": "Tax notice",
    "consignment_alert": "Consignment notice",
    "security_alert": "Security notice",
    "staff_locked": "Staff account locked",
    "dsar_overdue": "Personal data request is late",
    "queue_backlog": "Work is piling up",
    "mail_setup_problem": "E-mail sending is not set up right",
    "storage_threshold": "Storage almost full",
    "order_alert": "Order needs a look",
    "return_request": "Return request",
    "payment_alert": "Payment notice",
    "refund_failed": "Refund failed",
    "inventory_orphaned": "Stock without a product",
    "stock_discrepancy": "Stock numbers differ",
    "website_refresh_failed": "Website may not be updated",
    "manual": "Written by staff",
    "pending_payment_digest": "Daily list of unpaid orders",
    "daily_summary": "Daily summary",
    "inbox_escalation": "Urgent to-do still open"
  },
  "settings": {
    "title": "Notifications",
    "intro": "Who is told about what, what customers receive by e-mail, and the e-mails that went out.",
    "tab": {
      "people": "Who is told",
      "emails": "E-mails to customers",
      "sent": "Sent e-mails"
    },
    "error": "The notification settings could not be loaded.",
    "read_only": "Only the owner can change these settings. You can look.",
    "saved": "Notification settings saved.",
    "conflict": "Someone else saved these settings first. The newest version is shown — make your change again.",
    "save": "Save",
    "undo_changes": "Undo my changes"
  },
  "recipients": {
    "title": "Who gets alerts",
    "intro": "Every to-do is in the to-do list. Here you choose who also gets an e-mail or a chat message.",
    "everything": "Gets every alert",
    "how_default": "How (every alert)",
    "for_type": "Also for “{{type}}”",
    "how": "How",
    "remove_type": "Remove this line",
    "add_type": "Add people for one kind of alert…",
    "nobody": "Nobody yet",
    "remove": "Remove {{name}}",
    "add_staff": "Add a staff member…",
    "add_email": "or type an e-mail address",
    "add": "Add",
    "bad_email": "This does not look like an e-mail address.",
    "always_inbox": "To-do list: always",
    "channel": {
      "email": "E-mail",
      "webhook": "Chat (Discord)"
    }
  },
  "webhooks": {
    "title": "Chat (Discord)",
    "intro": "Alerts can also go to a Discord channel. The address is kept secret — it is never shown again after saving.",
    "none": "No chat channel yet.",
    "name": "Name",
    "url": "Address from Discord",
    "url_replace": "New address (leave empty to keep the old one)",
    "enabled": "On",
    "all_alerts": "Every alert",
    "some_alerts_one": "{{count}} kind of alert",
    "some_alerts_other": "{{count}} kinds of alerts",
    "test": "Send a test",
    "remove": "Remove",
    "add": "Add a chat channel",
    "test_sent": "Test message sent.",
    "test_failed": "The chat did not accept the test message. Check the address."
  },
  "sender": {
    "title": "Sender of shop e-mails",
    "name": "Sender name ({{language}})",
    "address": "Sender address",
    "reply_to": "Replies go to",
    "empty_uses_default": "Empty boxes use the value shown in grey."
  },
  "times": {
    "title": "Times",
    "digest": "Daily list of unpaid orders at",
    "daily_summary": "Daily summary at",
    "low_stock": "Low stock when this many or fewer are left"
  },
  "problems": {
    "from_address": "The sender address is not an e-mail address.",
    "reply_to": "The reply address is not an e-mail address.",
    "digest_time": "Enter the time as hours:minutes.",
    "daily_summary_time": "Enter the summary time as hours:minutes.",
    "low_stock": "Low stock: enter a whole number.",
    "webhook_url": "A new chat channel needs its https:// address from Discord.",
    "webhook_name": "Every chat channel needs a name."
  },
  "lang": {
    "en": "English",
    "ja": "日本語",
    "th": "ไทย",
    "zh-Hant": "繁體中文",
    "zh-Hans": "简体中文"
  },
  "emails": {
    "intro": "What customers receive, with example data. The wording is changed by the system team — this page only shows it.",
    "which": "E-mail",
    "off": "switched off",
    "language": "Language",
    "send_test": "Send a test to me ({{email}})",
    "error": "The e-mails could not be loaded.",
    "preview_error": "This e-mail could not be shown.",
    "subject": "Subject",
    "fallback": "Not written in this language yet — customers get the {{language}} version.",
    "frame_title": "E-mail: {{subject}}",
    "show_text": "Show the plain-text copy",
    "hide_text": "Hide the plain-text copy",
    "test_sent": "Test e-mail sent to {{email}}."
  },
  "sent": {
    "failed_only": "Only e-mails that failed",
    "error": "The sent e-mails could not be loaded.",
    "empty": "No e-mails here.",
    "hidden": "hidden",
    "open": "Open",
    "one_title": "E-mail",
    "resend": "Send again",
    "resent": "The e-mail will be sent again.",
    "to": "To",
    "state": "Status",
    "when": "When",
    "problem": "Problem",
    "body_hidden": "The content is only visible to staff who may see customer details.",
    "body_gone": "The copy of this e-mail is no longer kept.",
    "status": {
      "queued": "Waiting",
      "sending": "Sending",
      "sent": "Sent",
      "failed": "Failed",
      "suppressed": "Not sent (address blocked)",
      "bounced": "Came back",
      "skipped": "Not sent (customer switched it off)"
    },
    "error_code": {
      "other": "The mail server did not accept it."
    }
  }
}
